import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-backoffice',
  templateUrl: './backoffice.component.html'
})

export class BackOfficeComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document) { 
  }

  ngOnInit() {
      this.document.location.href ="https://www.lawshelf.com:8443/backoffice";
  }
}
